import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { TransferState, makeStateKey } from '@angular/core';
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformServer, Location } from '@angular/common';
import { tap } from 'rxjs/operators';

export class TranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: object,
    private location: Location,
    public prefix: string = '/assets/i18n/',
    public suffix: string = '.json'
  ) {}

  /**
   * Gets the translations from server or transferkey
   */
  public getTranslation(lang: string): Observable<object> {
    // prepare and load translations from already loaded HTML
    const translationKey = makeStateKey<object>('translation-' + lang);
    if (this.transferState.hasKey(translationKey)) {
      const translations = this.transferState.get<object>(translationKey, null);
      this.transferState.remove(translationKey);
      return of(translations);
    }

    const url = `${this.prefix}${lang}${this.suffix}`;
    return this.http
      .get(
        // we need to make sure, external webcomponents, iframe proj, ssr and client rendering use the correct base href settings.
        // as most environments load relative to the domain + /.../....de.json and only use explicit absolute base href with httpx...
        // we need to make sure all of them built a useable url
        this.location.prepareExternalUrl('').startsWith('http') ? this.location.prepareExternalUrl(url) : url,
        { transferCache: false }
      )
      .pipe(
        tap(translations => {
          // loaded translations, if on server, persist to transferstate for client
          if (isPlatformServer(this.platformId)) {
            this.transferState.set(translationKey, translations);
          }
        })
      );
  }
}
